import { Colors, Language, Lightning } from '@lightningjs/sdk'
import onAir from '../onAir'

export default class RadioInfo extends Lightning.Component {
  static _template() {
    return {
      InfoWrapper: {
        w: 580,
        y: 115,
        OnAir: {
          type: onAir,
          visible: true,
          onAirLabel: Language.translate('OnAir'),
        },
        Name: {
          y: 50,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('name'),
            textAlign: 'left',
            fontSize: 55,
            fontFace: 'OpenSansbold',
            lineHeight: 75,
            wordWrapWidth: 500,
          },
        },
        Schedule: {
          color: Colors('white').get(),
          text: {
            text: this.bindProp('schedule'),
            textAlign: 'left',
            fontSize: 30,
            lineHeight: 35,
            wordWrapWidth: 500,
          },
        },
      },
    }
  }

  set infoData(data) {
    this.patch({
      name: data.name,
      schedule: data.schedule,
    })
  }

  set onAirShow(txt) {
    this.tag('OnAir').onAirLabel = txt
  }
  _init() {
    this.tag('Name').on('txLoaded', () => {
      this.tag('Schedule').y = this.tag('Name').y + this.tag('Name').finalH - 20
      this.tag('InfoWrapper').y =
        115 + (270 - this.tag('Name').finalH + this.tag('Schedule').finalH) / 2
    })
  }
}
